import { render } from "./ManageNewsPage.vue?vue&type=template&id=4e2f6739"
import script from "./ManageNewsPage.vue?vue&type=script&lang=ts"
export * from "./ManageNewsPage.vue?vue&type=script&lang=ts"

import "./ManageNewsPage.vue?vue&type=style&index=0&id=4e2f6739&lang=scss"
script.render = render

export default script